import { create } from 'zustand';
import { IDataTable } from '@shared/models/data-table.model';

interface IDataTableDialogState {
  isOpen: boolean;
  dataTable?: IDataTable;
  resolve?: (dataTable?: IDataTable) => void;
}

export const useDataTableDialogStore = create<IDataTableDialogState>(() => ({
  isOpen: false,
}));

/**
 * Check if the data table dialog is open
 */
export const useIsDataTableDialogOpen = (): boolean => {
  return useDataTableDialogStore((state) => state.isOpen);
};

/**
 * Close the data table dialog
 * @param dataTable The data table to return (if any)
 */
export const closeDataTableDialog = (dataTable?: IDataTable) => {
  const resolve = useDataTableDialogStore.getState().resolve;
  if (resolve) {
    resolve(dataTable);
  }
  useDataTableDialogStore.setState({
    isOpen: false,
    dataTable: undefined,
    resolve: undefined,
  });
};

/**
 * Open the data table dialog
 * @param dataTable Optional data table to edit
 * @returns Promise that resolves with the created/updated data table or undefined if cancelled
 */
export const openDataTableDialog = (
  dataTable?: IDataTable,
): Promise<IDataTable | undefined> => {
  // Close any existing dialog
  closeDataTableDialog();

  return new Promise<IDataTable | undefined>((resolve) => {
    useDataTableDialogStore.setState({
      isOpen: true,
      dataTable,
      resolve,
    });
  });
};
